import { render } from "./FeaturedRafflesElement.vue?vue&type=template&id=0cbb89f9"
import script from "./FeaturedRafflesElement.vue?vue&type=script&lang=js"
export * from "./FeaturedRafflesElement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__